import './Expert.scss';

import React from 'react';

import useWindowSize from '../../../hooks/useWindowSize';
import DonneesPersonnelsExpert, { typeTraitementEnum } from './DonneesPersonnelsExpert';
import DrawSideBar from './SideBar';
import SideBarMobile from './SideBarMobile';

function ExpertStep1() {
    // ? we pass the function set Image to the child
    const {device}=useWindowSize();
    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                    <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Profile'}
                        etapSuivante='Données CV'
                        number='1'
                    />
                }

                <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',justifyContent:'space-between',width:'100%'}}>
                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center',padding:device=='desktop'?'0px':'16px',paddingTop:device=='desktop'?'64px':'16px'}}>
                        <DonneesPersonnelsExpert typeTraitement={typeTraitementEnum.EXPERT_COMPLETE_PROFILE} />
                    </div>
                    {device=='desktop'&&
                    <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg
                            width="315"
                            height="70"
                            viewBox="0 0 315 70"
                            fill="none"
                            style={{overflowX: 'visible'}}
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M102.277 21.7976C32.5361 27.7376 -11.6632 87.9364 3.55495 156.255C7.50398 173.984 25.3761 187.106 43.4735 185.565L383.506 156.603C401.665 155.056 413.174 139.381 409.212 121.592L388.856 30.2105C384.894 12.4211 366.96 -0.74615 348.8 0.800557L102.277 21.7976Z"
                                fill="#E3F5EA"
                            />
                        </svg>
                    </div>
                    }
                </div>
            </div>

            {/*
            <motion.div
                className="col-md-6 offset-md-3 StepDiv"
                initial={{ x: '-100vw' }}
                animate={{ x: 0 }}
                transition={{ stiffness: 150 }}
            >
                <h1 className='text-nowrap'>Dites nous plus sur vous!</h1>
            </motion.div>
            */}
        </>
    );
}

export default ExpertStep1;

// import { useForm } from 'react-hook-form';
// import { yupResolver } from "@hookform/resolvers/yup"
// import * as yup from "yup";

// const schema = yup.object().shape({
//     tele: yup.string().required(),
//     genre: yup.string().required(),
//     intitulePoste: yup.string().required(),
//     // photo: yup.mixed().required(),
//     // age: yup.number().positive.integer.required(),
//     // email: yup.string().email.required(),
//     // pwd: yup.string().min(4).max(15).required
//     // confirmPassword: yup.String().oneOf([yup.ref("pwd"),null].required

//     // terms: yup.bool().required().oneOf([true], 'terms must be accepted'),
// });

// const [Url, setUrl] = useState(null);
//* Already exists nom: { type: String, required: true, trim: true },
// * const { user } = props;

// ! SOOO Intressting Yup Formik Confirm password ..
// https://youtu.be/UvH70UkbyfE?t=532
// https://react-bootstrap.github.io/forms/validation/

// fct to determine wich fields we are intresting on
// const { register, handleSubmit, errors } = useForm({
//     resolver: yupResolver(schema),
//     // defaultValues: {
//     //     first_name: user.first_name,
//     //     last_name: user.last_name
//     // }
// });

// ! <p className="errorMsg">  {errors.confirmpwd && "password should match !"} </p>

